Wlz.handleAutocompleteOff = function() {
    setTimeout(function() {
        $('input[autocomplete=off]').each(function(){
            if(!this.hasAttribute('is')) {
                $(this).removeAttr('readonly');
            }
        });
        // On some browsers (Chrome, for example) inputs should be unmodified, but chrome autocomplete them.
        // So we set it as readonly, and then it's no more filled at page launch

    },100);
};

Wlz.handleAutocompleteOff();
